<div class="baseChart_style">
    <canvas baseChart
            [datasets]="chartData"
            [labels]="dateFormatLabels"
            [options]="lineChartOptions"
            [legend]="chartLegend"
            [type]="chartType"
></canvas>

</div>
<!-- [colors]="colorArray" -->